
import { TRUCK_MENU_ITEM, TRUCKS_SETTINGS } from "@/consts";
import TrucksTable from "@/components/TrucksTable.vue";
import TruckFilters from "@/components/truck/TruckFilters.vue";
import TrucksActions from "@/components/truck/TrucksActions.vue";
import Vue from "vue";
import { getModule } from "vuex-module-decorators";
import TruckModule from "@/store/modules/truck";
import Component from "vue-class-component";

const truckModuleState = getModule(TruckModule);

@Component({
  components: {
    TrucksTable,
    TrucksActions,
    TruckFilters
  }
})
export default class TruckSummary extends Vue {
  showTruckFieldFilter: boolean = false;
  showTrucks: boolean = false;
  truckMenuStyle: string = "";
  clickLocation: any = null;
  TRUCK_MENU_ITEM: any = TRUCK_MENU_ITEM;
  TRUCKS_SETTINGS: any = TRUCKS_SETTINGS;

  get truckFields() {
    return truckModuleState.truckFields;
  }

  async created() {
    await truckModuleState.setLoading(true);
    await truckModuleState.getTrucks({
      pageNumber: 1,
      pageSize: truckModuleState.pageData.pageSize
    });
    await truckModuleState.setLoading(false);
  }
  async loadMoreTrucks() {
    await truckModuleState.setLoading(true);
    await truckModuleState.getTrucks(null);
    await truckModuleState.setLoading(false);
  }
  toggleChangeTruckField(idx, hideShow) {
    truckModuleState.toggleTruckField({ idx: idx, value: !hideShow });
  }

  newTruck() {
    this.$router.push({ name: "NewTruck" });
  }

  exportTrucks() {
    return truckModuleState.exportTrucks();
  }

  importTrucks() {
    this.$router.push({ name: "ImportTrucks" });
  }

  get menuItemsToDisplay() {
    return this.TRUCK_MENU_ITEM.filter(
      x => x.requiresPermission === undefined || this.hasPermission(x.requiresPermission)
    );
  }
}
